import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router';
import PropTypes from 'prop-types';

import styled from '@mui/material/styles/styled';

import useAlarms from '../../../store/hooks/useAlarms';
import NoOrgMessage from './NoOrgsMessage';

const Main = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  backgroundColor: theme.palette.background.default,
}));

function MainContent({ appBarHeight }) {
  const location = useLocation();
  useAlarms();

  const loaderOpen = useSelector((state) => state.pages.loaderOpen);
  const organizations = useSelector((state) => state.organizations.data);

  return (
    <Main
      style={{
        marginTop: appBarHeight,
      }}>
      {!loaderOpen &&
      organizations.length === 0 &&
      location.pathname !== '/app/profile' ? (
        <NoOrgMessage />
      ) : (
        <Outlet />
      )}
    </Main>
  );
}

MainContent.propTypes = {
  appBarHeight: PropTypes.number.isRequired,
};

export default MainContent;
